import React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { MuiDialogProps } from './dialog-types';
import { ButtonDefault } from '../ButtonDefault';



export const MuiDialog: React.FC<MuiDialogProps> = (
  { open, title, children, loading, handleClose, handleSuccess, renderActions, ...rest },
) => {
  return (
    <Dialog
      open={open}
      onClose={() => handleClose && handleClose()}
      maxWidth="sm"
      fullWidth
      {...rest}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent style={{paddingBottom:0 }}>{children}</DialogContent>
      {renderActions && (
        <DialogActions >
          <Box display='flex' px={2}>
            <Box mr={1}>
              <ButtonDefault
                color="primary"
                variant="outlined"
                onClick={() => handleClose && handleClose()}>
                Cancel
              </ButtonDefault>
            </Box>
            <ButtonDefault
              variant='contained'
              onClick={() => handleSuccess && handleSuccess()}
              isLoading={loading}
            >
              Confirm
            </ButtonDefault>
          </Box>
        </DialogActions>
      )}
    </Dialog>
  );
};